import type { NuxtAxiosInstance } from '@/types/axios'
import utils from '@/utils'

interface FacebookLoginPayload {
  fbToken: string
  id: string
}

export async function facebookLogin(axios: NuxtAxiosInstance, { fbToken, id }: FacebookLoginPayload): Promise<any> {
  const res = await axios.$post('/fblogin', {
    fbToken,
    fbId: id,
    os: 'web',
    osVersion: window.navigator.userAgent,
    appVersion: '1.0',
    deviceId: utils.UUID,
  })

  if (res.code !== 0) {
    throw res
  }

  return res
}

interface GoogleLoginPayload {
  idToken: string
}

export async function googleLogin(axios: NuxtAxiosInstance, { idToken }: GoogleLoginPayload): Promise<any> {
  const res = await axios.$post('/login/google', {
    id_token: idToken,
    os: 'web',
    osVersion: window.navigator.userAgent,
    appVersion: '1.0',
    deviceId: utils.UUID,
  })
  if (res.code !== 0) {
    throw res
  }
  return res
}

interface AppleLoginPayload {
  identityToken: string
  authorizationCode: string
}

export async function appleLogin(axios: NuxtAxiosInstance, { identityToken, authorizationCode }: AppleLoginPayload): Promise<any> {
  const res = await axios.$post('/login/apple', {
    apple_token: identityToken,
    apple_auth_code: authorizationCode,
    os: 'web',
    osVersion: window.navigator.userAgent,
    appVersion: '1.0',
    deviceId: utils.UUID,
  })
  if (res.code !== 0) {
    throw res
  }
  return res
}

interface RegisterData {
  email: string
  name: string
  gender?: number | null
  birthday?: string
  osVersion: string
  deviceId: string
  fbId?: string
  fbToken?: string
  id_token?: string
  apple_token?: string
  apple_auth_code?: string
  userContract?: {
    isTermsAccepted: boolean
    isMarketingAllowed: boolean
  }
}
interface RegisterOptions {
  byFacebook?: boolean
  byGoogle?: boolean
  byApple?: boolean
}

export async function register(axios: NuxtAxiosInstance, data: RegisterData, options: RegisterOptions = { byFacebook: false }): Promise<any> {
  try {
    const defaultData = {
      ...data,
      fromFacebook: options.byFacebook ?? false,
      from_google: options.byGoogle ?? false,
      from_apple: options.byApple ?? false,
      os: 'web',
      appVersion: '1.0',
    }
    const registerData = Object.assign(defaultData, data)

    const res = await axios.$post('/register', registerData)
    if (res.code !== 0) {
      throw res
    }

    return res
  } catch (error) {
    console.error('register by facebook err: ', error)
    throw error
  }
}

export async function getZendeskJwt(axios: NuxtAxiosInstance): Promise<any> {
  const res = await axios.$get('/zendesk/token')
  return res
}
